import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import labService from './labService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './css/Lab.css';
import './css/ChooseModel.css';
import token_red from './images/token-red.png'
import token_green from './images/token_nqtb.png'

const ChooseModel = ({ isCollapsed, toggleSidebar }) => {
    const { endpointPk, analysisPk } = useParams();
    const [endpointDetails, setendpointDetails] = useState(null);
    const [modelsList, setModelsList] = useState([]);
    const [error, setError] = useState(null);
    const [expandedModelId, setExpandedModelId] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedModels, setSelectedModels] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('user'))?.access;
        
        if (!token) {
            setError("You must be logged in to view this page.");
            return;
        }

        const fetchSelectModels = async () => {
            try {
                const response = await labService.getMLModelsByEndpoint(endpointPk, token);
                setModelsList(response.data);
                console.log(response.data);
                // const firstModelId = response.data.ml_models[0].id;
                // setSelectedModelId(firstModelId)
                // const modelDetailsResponse = await labService.getModelDetails(firstModelId, token);
                // setSelectedModelDetails(modelDetailsResponse.data.model_details);

            } catch (error) {
                console.error('Error fetching prediction details:', error);
                setError('Failed to fetch models. Please try again.');
            }
        };

        const fetchEndpointDetails = async () => {
            try {
                const response = await labService.getEndpointDetail(endpointPk, token);
                console.log(response.data);
                setendpointDetails(response.data);

            } catch (error) {
                console.error('Error fetching endpoint details:', error);
                setError('Failed to fetch endpoint. Please try again.');
            }
        };

        const fetchAnalIfPk = async () => {
            // Only run this function if analysisPk is defined
            if (analysisPk) {
                try {
                    const response = await labService.getAnalysisDetail(analysisPk, token);
                    console.log(response.data);
                    setSelectedModels(response.data.selected_models);
    
                } catch (error) {
                    console.error('Error fetching analysis details:', error);
                    setError('Failed to fetch Analysis. Please try again.');
                }
            }
        };
        
        fetchEndpointDetails();
        fetchSelectModels();
        fetchAnalIfPk();
    }, [endpointPk, analysisPk]);

    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
            
        };

        fetchUserData();
    }, []);


    const toggleExpand = (modelId) => {
        setExpandedModelId((prevId) => (prevId === modelId ? null : modelId));
    };

    const handleNext = () => {
        localStorage.setItem('selectedModels', JSON.stringify(selectedModels));
        
        // Check if analysisPk exists and navigate accordingly
        const path = analysisPk ? `/new-pred/${analysisPk}` : '/new-pred';
        navigate(path);
    };
    

    const closeSelectModels = () => {
        navigate(-1);
    };

    const handleCheckboxChange = (modelId) => {
        setSelectedModels((prevSelectedModels) => {
            if (prevSelectedModels.includes(modelId)) {
                // Remove the model if it's already selected
                return prevSelectedModels.filter((id) => id !== modelId);
            } else {
                // Add the model if it's not already selected
                return [...prevSelectedModels, modelId];
            }
            
        });
    };

    const totalCost = selectedModels.reduce((acc, selectedId) => {
        const model = modelsList.find(m => m.id === selectedId);
        return acc + (model ? model.model_price : 0);
      }, 0);
    
    const formatKey = (key) => {
        if (key === 'Q^2_LOO') {
            return (
                <>
                    Q<sup>2</sup><sub>LOO</sub>
                </>
            );
        } else if (key === 'R^2') {
            return (
                <>
                    R<sup>2</sup>
                </>
            );
        } else if (key === 'CCC_CV') {
            return (
                <>
                    CCC<sub>CV</sub>
                </>
        );
        } else if (key === 'Q^2_F1') {
            return (
                <>
                    Q<sup>2</sup><sub>F1</sub>
                </>
            );
        } else if (key === 'Q^2_F2') {
            return (
                <>
                    Q<sup>2</sup><sub>F2</sub>
                </>
            );
        } else if (key === 'Q^2_F3') {
            return (
                <>
                    Q<sup>2</sup><sub>F3</sub>
                </>
            );
        } else if (key === 'CCC_EXT') {
            return (
                <>
                    CCC<sub>EXT</sub>
                </>
        );
        }
    
        return key; // Return the key as-is if no formatting is required
    };

    const getStaticUrl = (filename) => {
        // Assuming your Django backend is on port 8000 in development
        const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        return `${backendUrl}static/qmrf/${filename}`;
    };

    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={closeSelectModels} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps active-tab-cm'>
                            <p className='p-step'>STEP 1</p>
                            <p>Select Model</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 2</p>
                            <p>Define Compound</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 3</p>
                            <p>Summary</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 4</p>
                            <p>Results</p>
                        </div>
                
                    </div>
                    
                        {endpointDetails && modelsList ? (
                            <div className='models-cont'>

                                <div className="mdls-container">
                                    <div className='up-sel-mod'>
                                        {modelsList.map((model) => (
                                            <div key={model.id} className="model-row">
                                                <div className="model-header">
                                                    <div className='name-chevron' onClick={() => toggleExpand(model.id)}>
                                                        <FontAwesomeIcon
                                                            className="chevron-icon"
                                                            icon={expandedModelId === model.id ? faChevronUp : faChevronDown}
                                                        />
                                                        <p className='mdl-name'>{model.model_name}</p>
                                                    </div>
                                                    <div className='cost-div'>
                                                        <img
                                                            className="token-cost-sm"
                                                            src={user && user.coins < model.model_price ? token_red : token_green}
                                                            alt="token icon"
                                                        />
                                                        <p className='mdl-price-p'>
                                                            {model.model_price} {model.model_price === 1 ? "token" : "tokens"}
                                                        </p>
                                                        
                                                    </div>
                                                    
                                                    <input
                                                        className='models-check'
                                                        type="checkbox"
                                                        checked={selectedModels.includes(model.id)}
                                                        onChange={() => handleCheckboxChange(model.id)}
                                                    />
                                                </div>
                                                {expandedModelId === model.id && (
                                                <div className="model-detale">
                                                    <div className='detail-1'>
                                                        <p className='det-main'>Model description</p>
                                                        <p className='det-p'>{model.model_description}</p>
                                                        <p className='det-sec'>Type of model</p>
                                                        <p className='det-p'>{model.method_type}</p>
                                                        <p className='det-sec'>Descriptors</p>
                                                        <p className='det-p' style={{ whiteSpace: 'pre-line' }}>
                                                            {model.model_details.descriptors_desc?.join('\n')}
                                                        </p>
                                                        <p className='det-sec'>Statistics</p>
                                                        <div className='det-p'>
                                                            {Object.entries(model.model_details.statistics).map(([key, value]) => (
                                                                <div key={key}>
                                                                <strong>{formatKey(key)}</strong>: {value}
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </div>
                                                    <div className='detail-2'>
                                                        <p className='det-main'>Endpoint description</p>
                                                        {/* <p className='det-p'>{endpointDetails.endpoint_description}</p> */}
                                                        <p className='det-p'>{model.model_details.endpoint_desc}</p>
                                                        <p className='det-main'>Type of compounds for model applicability</p>
                                                        <p className='det-p'>{model.model_details.model_applicability}</p>
                                                        <p className='det-main'>QMRF</p>
                                                        {model.model_details?.qmrf_filename && (
                                                        <p className='det-p'>
                                                            <strong>QMRF Report: </strong>
                                                            <a 
                                                            href={getStaticUrl(model.model_details.qmrf_filename)}
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="qmrf-link"
                                                            >
                                                            View PDF Report ↗
                                                            </a>
                                                        </p>
                                                        )}
                                                    </div>
                                                    <div className='detail-3'>
                                                        {/* <div className='cost-div'>
                                                            <img
                                                                className="token-cost"
                                                                src={user && user.tokens < model.model_price ? token_red : token_green}
                                                                alt="token icon"
                                                            />
                                                            <p className={`cost ${user && user.tokens < model.model_price ? 'not-enough-tokens' : ''}`}>{`Cost: ${model.model_price} tokens`}</p>
                                                        </div> */}
                                                    </div>                                            
                                                </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="btm-sel-mod">
                                        {user && user.coins < totalCost ? (
                                            <div className="message-left">
                                                <p className="not-enough-tokens">You do not have enough tokens to make this amount of predictions.</p>
                                                <p className="grey-text">
                                                    Go to the <span className="boldy">Wallet tab</span> to top up your account with tokens.
                                                </p>
                                            </div>
                                        ) : (
                                            <div className="message-left placeholder"></div> /* Invisible placeholder */
                                        )}

                                        <button onClick={handleNext} className={`run-btn ${user && user.coins >= totalCost && totalCost > 0 ? 'next-but-ready' : 'next-but'}`}>
                                            Next
                                        </button>

                                        <div className="cost-div">
                                            <img
                                                className="token-cost-sm"
                                                src={user && user.coins < totalCost ? token_red : token_green}
                                                alt="token icon"
                                            />
                                            <p className={`${user && user.coins < totalCost ? 'not-cost-sm' : 'cost-sm'}`}>
                                                {`Cost: ${totalCost} token(s)`}
                                            </p>
                                        </div>
                                    </div>

                                </div>
                        
                            </div>

                        ): (<></>)}
                    
                    
                </div>    
            </div>
        </div>
    );
};

export default ChooseModel;